module.exports = __webpack_public_path__ + "static/media/mall-category-9.528ebd66.png";